import React from 'react';
import { SanityImage, Dataset, safeImageUrl } from '../../../lib/landingPage';
import { Wrapper } from '../Wrapper';
import { Image as AntImage } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-regular-svg-icons';

export type ImageProps = {
    image: SanityImage;
    caption: string;
    alt: string;
    dataset?: Dataset;
    lazy?: boolean;
    preview?: boolean;
    className?: string;
};

export const Image = Wrapper(
    ({
        alt,
        caption,
        lazy = true,
        image,
        dataset,
        className,
        preview = false,
    }: ImageProps) => {
        const resolvedImage = safeImageUrl(image, dataset);
        if (!resolvedImage) return null;
        return !preview ? (
            <img
                loading={lazy ? 'lazy' : 'eager'}
                src={resolvedImage.url()}
                alt={alt}
                title={caption}
                className={className}
            />
        ) : (
            <AntImage
                loading={lazy ? 'lazy' : 'eager'}
                src={resolvedImage.url()}
                alt={alt}
                title={caption}
                className={className}
                preview={{
                    wrapStyle: { backgroundColor: 'rgba(0, 0, 0, 0.75)' },
                    mask: (
                        <div className="horizontal center-middle g4">
                            <FontAwesomeIcon icon={faEye} />
                            Visualizar
                        </div>
                    ),
                }}
            />
        );
    },
    'img'
);
